<template>
	<Card :class="content_class">
		<div>
			<Card :bordered="false" dis-hover class="ivu-mb-16">
				<Form ref="formValidate" :model="formValidate" label-width="100" label-position="right" class="tabform"
					@submit.native.prevent>
					<Row :gutter="24" type="flex">
						<Col span="24">
						<FormItem label="时间选择：">
							<RadioGroup v-model="timePeriod" type="button" class="mr" @on-change="getList">
								<Radio label="0"><span>不限</span></Radio>
								<Radio label="1"><span>今日</span></Radio>
								<Radio label="2"><span>昨日</span></Radio>
								<Radio label="3"><span>本周</span></Radio>
								<Radio label="4"><span>上周</span></Radio>
								<Radio label="5"><span>本月</span></Radio>
								<Radio label="6"><span>上月</span></Radio>
								<Radio label="7"><span>自定义</span></Radio>
								<DatePicker v-show="timePeriod == '7' " :value="timePeriodDate"
									@on-change="timePeriodDateChange" type="daterange" placeholder="选择日期"
									style="width: 200px"></DatePicker>
							</RadioGroup>
							<Button type="primary" class="bnt mr15" icon="md-add" style="margin-left: 20px;" @click="addRechargeModal">记账</Button>
						</FormItem>
						</Col>
						<Col span="24">
						<FormItem label="账户：">
								<RadioGroup type="button" v-model="bankid" class="mr15" @on-change="getList">
									<Radio label="0"><span>全部</span></Radio>
									<Radio :label="item.id" v-for="(item,index ) in bankIdList" :key="index">{{item.bankname}}</Radio>
								</RadioGroup>
							</FormItem>
						</Col>
						<Col span="24">
						<FormItem label="交易类型：">
								<RadioGroup type="button" v-model="classType" class="mr15" @on-change="getList">
									<Radio label="0"><span>全部</span></Radio>
									<Radio :label="item.id" v-for="(item,index ) in classTypeList" :key="index">{{item.classname}}</Radio>
								</RadioGroup>
							</FormItem>
						</Col>
					</Row>
				</Form>
			</Card>
			<div style="width: 100% ;margin-top: 20px;">
				<Table :columns="columns" :data="datas" ref="table">
					<template slot-scope="{ row, index }" slot="acmoney">
						<div style="margin: 10px;color: red;">
							<span v-if="row.pay_type == 1">+{{row.acmoney}}</span>
						</div>
						<div style="margin: 10px;color: green;">
							<span v-if="row.pay_type == 2">-{{row.acmoney}}</span>
						</div>
					</template>
					<template slot-scope="{ row, index }" slot="action">
						<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id"
							:data-index="index" @click="editFlow">编辑</Button>
						<Button type="error" size="small" :data-id="row.id" @click="delFlow">删除</Button>
					</template>
				</Table>
			</div>
			<div class="pager">
				<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
					:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small"
					show-elevator />
			</div>
			<!-- 提现申请 -->
			<Modal v-model="modal" width="500" title="添加充值">
				<Form :label-width="120">
					<FormItem label="银行卡">
						<Select v-model="rechargeForm.bankid">
							<Option v-for="item in bankIdList" :value="item.id" :key="item.id">
								{{item.bankname }}-[{{item.remark}}]
							</Option>
						</Select>
					</FormItem>
					<FormItem label="日期">
						<DatePicker type="date" :value="rechargeForm.actime" @on-change="rechargeTimeChange"
							placeholder="Select date"></DatePicker>
					</FormItem>
					<FormItem label="类型">
						<Select v-model="rechargeForm.acclassid">
							<Option v-for="item in classTypeList" :value="item.id" :key="item.id">
								{{item.pay_type_name }}-[{{item.classname}}]
							</Option>
						</Select>
					</FormItem>
					<FormItem label="金额">
						<Input placeholder="金额" v-model="rechargeForm.acmoney"></Input>
					</FormItem>
					<FormItem label="备注">
						<Input placeholder="备注" v-model="rechargeForm.remark"></Input>
					</FormItem>
					<FormItem label="添加图片">
						<MyUpload ref="upload"></MyUpload>
					</FormItem>
				</Form>
				<div slot="footer">

					<Button type="primary" @click="rechargeSubmit">提交</Button>
					<Button type="default" @click="modal = false">取消</Button>
				</div>
			</Modal>
		</div>
	</Card>
</template>
<script>
	import {
		mapGetters,
		mapActions
	} from "vuex";
	import MyUpload from '../tool/Upload.vue';
	import {
		getFlowList,
		getBankIdList,
		getAllClassTypeList,
		addFlow,
		getFlow,
		delFlow,
	} from "../../api/financeManage";

	export default {
		name: "FinanceFlow",
		components: {
			MyUpload
		},
		props: ['content_class'],
		data() {
			return {
				count: 0,
				page: 1,
				pageSize: 10,
				pageSizeOpts: [10, 50, 100, 500],
				name: '',
				modal: false,
				timePeriod: '5',
				timePeriodDate: [],
				rechargeForm: {
					recharge_date_time: '',
					arrival_amount: '',
					remark: '',
					status: 0
				},
				bankIdList: [],
				classTypeList: [],
				bankid:'0',
				classType:'0',
				datas: [],
				fromList: {
					title: '选择时间',
					custom: true,
					fromTxt: [{
							text: '全部',
							val: ''
						},
						{
							text: '今天',
							val: 'today'
						},
						{
							text: '昨天',
							val: 'yesterday'
						},
						{
							text: '本周',
							val: 'week'
						},
						{
							text: '本月',
							val: 'month'
						},
						{
							text: '本季度',
							val: 'quarter'
						},
						{
							text: '本年',
							val: 'year'
						},
					],
				},
				formValidate: {
					status: '',
					extract_type: '',
					nireid: '',
					data: '',
					page: 1,
					limit: 20,
				},
				columns: [{
						"title": "账户",
						"key": "bankname",
						align: 'center'
					}, {
						"title": "交易日期",
						"key": "actime",
						align: 'center'
					},
					{
						"title": "交易金额",
						"key": "acmoney",
						align: 'center'
					},
					{
						"title": "创建时间",
						"key": "created_at",
						align: 'center'
					},
					{
						"title": "备注",
						"key": "remark",
						align: 'center'
					},
					{
						"title": "操作人",
						"key": "name",
						align: 'center'
					},
					{
						title: 'Action',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
				columnsCopy: [{
						"title": "账户",
						"key": "bankname",
						align: 'center'
					}, {
						"title": "交易日期",
						"key": "actime",
						align: 'center'
					},
					{
						"title": "交易金额",
						"slot": "acmoney",
						align: 'center'
					},
					{
						"title": "交易类型",
						"key": "classname",
						align: 'center'
					},
					{
						"title": "余额",
						"key": "balance",
						align: 'center'
					},
					{
						"title": "备注",
						"key": "remark",
						align: 'center'
					},
					{
						"title": "操作人",
						"key": "name",
						align: 'center'
					},
					{
						"title": "创建时间",
						"key": "created_at",
						align: 'center'
					},
					{
						title: 'Action',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
				balance: '***',
				consume: '***'
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.userDisplayTable();
			this.loadData();
			this.getList();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			timePeriodDateChange(e) {
				this.timePeriodDate = e;
				this.getList();
			},
			rechargeTimeChange(e) {
				this.rechargeForm.actime = e;
			},
			initSearch() {

			},
			// 具体日期
			onchangeTime(e) {
				this.timeVal = e;
				this.formValidate.data = this.timeVal.join('-');
				this.formValidate.page = 1;
				this.getList();
			},
			// 选择时间
			selectChange(tab) {
				this.formValidate.page = 1;
				this.formValidate.data = tab;
				this.timeVal = [];
				this.getList();
			},
			addRechargeModal() {
				this.rechargeForm = {};
				this.$refs['upload'].uploadList = [];
				this.modal = true;
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getBankIdList(that, data);
				that.bankIdList = res.data.list;
				res = await getAllClassTypeList(that, data);
				that.classTypeList = res.data.list;
			},
			async getList() {
				let that = this;
				let data = {
					token: that.token,
					timePeriod: that.timePeriod,
					timePeriodDate: that.timePeriodDate,
					bankid: that.bankid,
					classType: that.classType,
					page: that.page,
					pageSize: that.pageSize
				};
				let res = await getFlowList(that, data);
				if (res.code == 1) {
					that.datas = res.data.list;
					that.count = res.count;
				}
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			async rechargeSubmit() {
				let that = this;
				if (that.rechargeForm.status != 1) {
					that.rechargeForm.status = 0;
				}
				let data = {
					token: that.token,
					rechargeForm: that.rechargeForm,
					imgList: that.$refs['upload'].uploadList
				};
				let res = await addFlow(that, data);
				if (res.code == 1) {
					this.modal = false;
					this.getList();
				}
			},
			userDisplayTable() {
				// type: 4 分公司负责人   5 区长n)
				if (this.userInfo.role_type == 13) { //此处判断不用用户类型是否有有对应的列权限
					this.columns = this.columns.filter(col => col.slot !== 'action')
					this.columns = this.columns.filter(col => col.key !== 'remark')
				} else {
					this.columns = this.columnsCopy
				}
			},
			// 编辑充值
			async editFlow(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {
					token: that.token,
					id: id,
					imgList: that.$refs['upload'].uploadList
				};
				let res = await getFlow(that, data);
				if (res.code == 1) {
					var jsonStr = JSON.parse(res.data.item.ext_info); //将视频和图片的json转为数据
					that.$refs['upload'].uploadList = jsonStr.imgList;
					that.rechargeForm = res.data.item;
					that.modal = true;
				}
			},
			// 删除充值
			delFlow(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await delFlow(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
			recharge() {
				window.open('#/PayInfo')
			}
		},


	}
</script>
<style scoped lang="less">
	.content {}
	.ivu-mt .type .item {
	  margin: 3px 0;
	}
	
	.tabform {
	}
	
	.content1 {
		height: 650px;
		overflow-y: auto;
		overflow-x: hidden
	}

	.yellow_btn {
		color: #F8BD66;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}


	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}
</style>